<template>
  <v-dialog width="500" v-model="showNationalityForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} Nationality </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showNationalityForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="nationalityForm"
          v-if="showNationalityForm"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="Nationality Name *"
                required
                :rules="[
                  (val) => !!val || 'Nationality Name is required!',
                  (val) =>
                    $globals.lettersOnlyRegExp.test(val) ||
                    'Invalid Nationality Name!',
                ]"
                hide-details="auto"
                v-model="nationalityDetails.nationality_name"
                :error-messages="formErrors.nationality_name"
                @input="delete formErrors.nationality_name"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-3"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editNationalityID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getNationalityObject(this.editNationalityID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showNationalityForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      isValid: true,
      isTextInput: false,
      nationalityDetails: {},
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.$api.nationality
          .addNationality(this.nationalityDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Nationality added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showNationalityForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add nationality!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.nationality
          .updateNationality({
            id: this.nationalityDetails.id,
            data: this.nationalityDetails,
          })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Nationality updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showNationalityForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update nationality!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.nationalityForm) {
        this.$refs.nationalityForm.reset();
      }
      this.nationalityDetails = {};
    },

    getNationalityObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.nationality
        .getNationalityObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.nationalityDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
